import { SHOW_MAX_SINK_QUANTITY_WARNING, HIDE_MAX_SINK_QUANTITY_WARNING } from '../actions/actionTypes';

const initialState = {
  showWarning: false,
  maxQuantity: null,
};

const sinkQuantityWarningReducer = (state = initialState, action) => {
  switch (action.type) {
  case SHOW_MAX_SINK_QUANTITY_WARNING:
    return {
      ...state,
      showWarning: true,
      maxQuantity: action.payload.maxQuantity,
    };
  case HIDE_MAX_SINK_QUANTITY_WARNING:
    return {
      ...state,
      showWarning: false,
    };
  default:
    return state;
  }
};

export default sinkQuantityWarningReducer;
